import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { SharedModule } from "../../shared.module";
import { ChangePasswordAfterLoginComponent } from "./change-password-after-login.component";

@NgModule({
    declarations: [ChangePasswordAfterLoginComponent],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatIconModule,
        TranslateModule,
        RouterModule,
        MatToolbarModule,
        MatButtonModule,
        FormsModule,
        FlexModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        MatCardModule,
        SharedModule,
        MatInputModule,
        NgxSpinnerModule
    ],
    exports: [ChangePasswordAfterLoginComponent]
})
export class ChangePasswordAfterLoginModule {}
